import gql from 'graphql-tag';

// interface UpdateTransferLineItems {
//   id: string;
//   externalId: string;
//   partNumber: string;
//   lotNumber: string;
//   productId: string;
//   quantity: string;
//   priceBookEntryId: string;
//   unitPrice: string;
//   status: string;
//   approvalStatus: string;
// }

// eslint-disable-next-line import/prefer-default-export
export const UPDATE_TRANSFER_INVENTORY = gql`
  mutation updateTransferInventory(
    $orderId: String
    $orderExternalId: String
    $accountId: String
    $salesRepId: String
    $receivingRepId: String
    $fromSubInventoryCode: String
    $toSubInventoryCode: String
    $salesOrganization: String
    $status: String
    $lineItems: [UpdateTransferLineItems]
    $comments: [Comment]
    $expectedCaseVersion: String
    $system: String
    $version: String
  ) {
    updateTransferInventory(
      status: $status
      orderId: $orderId
      orderExternalId: $orderExternalId
      accountId: $accountId
      salesRepId: $salesRepId
      receivingRepId: $receivingRepId
      fromSubInventoryCode: $fromSubInventoryCode
      toSubInventoryCode: $toSubInventoryCode
      salesOrganization: $salesOrganization
      lineItems: $lineItems
      comments: $comments
      expectedCaseVersion: $expectedCaseVersion
      system: $system
      version: $version
    ) {
      message
      externalId
    }
  }
`;
export default UPDATE_TRANSFER_INVENTORY;
